<script setup lang="ts">
  import { useThemeStore } from '@/stores/theme';
  import { computed } from 'vue';

  const themeStore = useThemeStore();

  const currentTheme = computed({
    get() {
      return themeStore.theme;
    },
    set(val) {
      themeStore.setTheme(val);
    },
  });
</script>

<template>
  <label class="label cursor-pointer">
    <span class="label-text">️☀️️</span>
    <input
      v-model="currentTheme"
      true-value="dark"
      false-value="light"
      type="checkbox"
      class="toggle toggle-warning -mx-1" />
    <span class="label-text">️🌙️</span>
  </label>
</template>
